// These are just placeholder functions for React web. Reset/lifecycle
// clears (clearUserAndRuntimeKeys, clearTenantScopedKeys, the namespace
// clears) are NOT here — they live in the native-only `resetPolicy.ts`,
// imported directly by `nuclearReset` (which never runs on web).
const noOp = () => null;

export const getDeviceIdAsync = () => Promise.resolve('');

export const getDomain = () => '';
export const setDomain = (_domain: string) => noOp();

export const getCookie = () => '';
export const setCookie = (_cookie: string) => noOp();
export const clearCookie = () => noOp();

export const setLanguage = (_language: string) => noOp();
export const getLanguage = () => '';

export const setRtlValue = (_rtlValue: string) => noOp();
export const getRtlValue = (): string => '';

export const getRefreshCookie = () => '';
export const setRefreshCookie = (_cookie: string) => noOp();
export const clearRefreshCookie = () => noOp();

export const getUserDetails = (): object | undefined => undefined;
export const setUserDetails = (_userDetails: object) => noOp();

export const setIsBiometricIDPEnabled = (_isBiometricIDPEnabled: boolean) => noOp();
export const getIsBiometricIDPEnabled = (): boolean => false;

export const setIsReloadTriggered = (_isReloadTriggered: boolean) => noOp();
export const getIsReloadTriggered = (): boolean => false;

export const setSkipStoredNavPostReload = (_skip: boolean) => noOp();
export const getSkipStoredNavPostReload = (): boolean => false;

export const setUsePublishedVersion = (_usePublishedVersion: boolean) => noOp();
export const getUsePublishedVersion = (): boolean => false;

export const setNavigationState = (_navigationState: unknown) => noOp();
export const getNavigationState = () => undefined;

export const getActiveAppVariant = () => '';
export const setActiveAppVariant = (_activeAppVariant: string) => noOp();

export const clearNativeCookies = () => {
  return Promise.resolve();
};
